import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MainRouter } from './core/routes'
import { MainAppRender } from '@reapitform/core'
import { ReapitConnectSessionProvider, StorageProvider } from '@reapitform/hooks'

import '@reapit/elements/dist/index.css'
import '@reapitform/dashboard-ui/dist/style.css'
import '@reapitform/common-ui/dist/style.css'
import '@reapitform/utils/dist/style.css'
import { reapitConnectBrowserSession } from './core/reapit-connect-session'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MainAppRender>
      <ReapitConnectSessionProvider reapitConnectSession={reapitConnectBrowserSession}>
        <StorageProvider>
          <MainRouter />
        </StorageProvider>
      </ReapitConnectSessionProvider>
    </MainAppRender>
  </StrictMode>,
)
